export function getParts(lines) {
  let parts = {};
  let part = [];
  for (let line of lines) {
    if (line.match(/^[A-Z]{4}.+$/)) {
      let partLabel = line.replace(/[ ,;]+$/, '');
      part = [];
      parts[partLabel] = part;
    } else if (!line.match(/^[ ,;]*$/)) {
      part.push(line);
    }
  }
  return parts;
}
